import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/i18n/translations';
import { useLocation } from 'react-router-dom';

export default function CookieConsent() {
  const { t } = useTranslation();
  const location = useLocation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Don't show cookie banner on widget pages
    if (location.pathname.startsWith('/widget-demo')) {
      setShowBanner(false);
      return;
    }

    // Check if user has already accepted cookies
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, [location]);

  const acceptCookies = () => {
    // Save consent to localStorage
    localStorage.setItem('cookie-consent', 'accepted');
    
    // Update Google Consent Mode v2
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'functionality_storage': 'granted',
        'personalization_storage': 'granted'
      });
    }
    
    setShowBanner(false);
  };

  const declineCookies = () => {
    // Save consent to localStorage
    localStorage.setItem('cookie-consent', 'declined');
    
    // Update Google Consent Mode v2 (only security storage granted)
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'denied',
        'personalization_storage': 'denied',
        'security_storage': 'granted'
      });
    }
    
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-4 border-black shadow-2xl z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-bold text-black mb-2">
              {t('cookies.title')}
            </h3>
            <p className="text-sm text-gray-600">
              {t('cookies.description')}{' '}
              <a 
                href="/cookie-policy" 
                className="underline hover:text-black font-medium"
              >
                {t('cookies.learnMore')}
              </a>
            </p>
          </div>
          <div className="flex gap-3 w-full sm:w-auto">
            <Button
              id="cookie-consent-decline"
              onClick={declineCookies}
              className="flex-1 sm:flex-none bg-gray-200 text-black hover:bg-gray-300 border-2 border-black"
            >
              {t('cookies.decline')}
            </Button>
            <Button
              id="cookie-consent-accept"
              onClick={acceptCookies}
              className="flex-1 sm:flex-none bg-black text-white hover:bg-gray-800 border-2 border-black"
            >
              {t('cookies.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
